module.exports = __webpack_public_path__ + "img/save_title.73ab5f38.png";